import { createStore } from 'owa-satcheljs';
import type CopilotPrioritizeSettings from '../types/CopilotPrioritizeSettings';
import type CopilotStyleSettings from '../types/CopilotStyleSettings';
import type CopilotTopicsPreferences from '../types/CopilotTopicsPreferences';
import type { AccountKey } from 'owa-client-types';

interface CopilotPrioritizeSettingsStore {
    isInitialized: boolean;
    settings: CopilotPrioritizeSettings;
    version: number;
}

interface CopilotStyleSettingsStore {
    isInitialized: boolean;
    settings: CopilotStyleSettings;
}

interface CopilotPersonalizationSettingsStore {
    isPersonalizationEnabled: boolean;
}

export interface GeneralPreferences {
    isCopilotUIDisabled: boolean; // true if the user chooses to disable Copilot UI which will hide all Copilot entrypoint UIs, but not affect teaching moments
    isMCPEnabled: boolean; // true if the user chooses to enable MCP
}

interface CopilotSettingsStoreMap {
    copilotPrioritizeSettingsStoreMap: Map<AccountKey, CopilotPrioritizeSettingsStore>;
    copilotStyleSettingsStoreMap: Map<AccountKey, CopilotStyleSettingsStore>;
    copilotGeneralPreferencesMap: Map<AccountKey, GeneralPreferences>;
    copilotTopicsPreferencesMap: Map<AccountKey, CopilotTopicsPreferences>;
    copilotPersonalizationSettingsMap: Map<AccountKey, CopilotPersonalizationSettingsStore>;
}

const defaultExport: () => CopilotSettingsStoreMap = createStore<CopilotSettingsStoreMap>(
    'copilotSettingsStore',
    {
        copilotPrioritizeSettingsStoreMap: new Map(),
        copilotStyleSettingsStoreMap: new Map(),
        copilotGeneralPreferencesMap: new Map(),
        copilotTopicsPreferencesMap: new Map(),
        copilotPersonalizationSettingsMap: new Map(),
    }
);
export default defaultExport;
